import React, { Component } from "react";
import PageHelmet from "../../component/common/Helmet";
import axios from "axios";
import Selectrix from "react-selectrix";
import Modal from "react-bootstrap/Modal";

import "react-toastify/dist/ReactToastify.css";
import ReactCountryFlag from "react-country-flag";
import FlipCountdown from "@rumess/react-flip-countdown";
import { GoRocket } from "react-icons/go";
import Spinner from "react-bootstrap/Spinner";
import { ToastContainer, toast } from 'react-toastify';
// import TestimonialOne from "../../blocks/testimonial/TestimonialOne";
import Typical from 'react-typical';
import { FiCheck, FiClock, FiUser, FiMonitor, FiRadio, FiDownload, FiVideo, FiCheckCircle, FiPackage} from "react-icons/fi";
import { FaRegCalendarAlt, FaWhatsapp,FaFilm, FaUserFriends, FaMedal } from "react-icons/fa";
// import { IoMdTime } from "react-icons/io";
// import BrandTwo from "../../elements/BrandTwo";
// import cx from "classnames";
// import NonPassiveTouchTarget from "../NonPassiveTouchTarget";
// import TouchCarousel, { clamp } from "react-touch-carousel";
// // import touchWithMouseHOC from "react-touch-carousel/lib/touchWithMouseHOC";
// import data2 from "../data2";
import { FaFacebookSquare } from "react-icons/fa";
import { FaStar } from "react-icons/fa";
import FooterTwoFunnel from "../../component/footer/FooterTwoFunnel";
import { IoVideocam } from "react-icons/io5";
import { MdAccessTimeFilled } from "react-icons/md";

const KeyCountry =  [
  {key: "PE", label: "Perú", countryNumber: "+51"},
  {key: "EC", label: "Ecuador", countryNumber: "+593"},
  {key: "GT", label: "Guatemala", countryNumber: "+502"},
  {key: "CR", label: "Costa Rica", countryNumber: "+506"},
  {key: "MX", label: "México", countryNumber: "+52"},
  {key: "SV", label: "El Salvador", countryNumber: "+503"},
  {key: "HN", label: "Honduras", countryNumber: "+504"},
  {key: "UY", label: "Uruguay", countryNumber: "+598"},
  {key: "PY", label: "Paraguay", countryNumber: "+595"},
  {key: "PA", label: "Panamá", countryNumber: "+507"},
  {key: "NI", label: "Nicaragua", countryNumber: "+505"},
  {key: "US", label: "Estados Unidos", countryNumber: "+1"},
]

// const KeyPaymentType =  [
//     {key: "1", label: "Ver ahora al instante"},
//     {key: "2", label: "Ver más tarde (hoy)"},
//     {key: "3", label: "mie. 4 de jun. de 2025"},
// ]


// const Container2 = touchWithMouseHOC(CarouselContainer2);

const cardSize = 300;
const cardSize2 = 280;
const cardPadCount = 2;
// const carouselWidth = clamp(window.innerWidth, 0, 960);

 const containerStyle = {
    display: "flex",
    flexDirection: window.type_device ? "column" : "row",
    gap: "1rem",
    width: "100%",
    padding: "1rem",
    boxSizing: "border-box",
  };

  // Estilo de cada tarjeta
  const cardStyle = {
    backgroundColor: "#E6F2FF",
    borderRadius: "8px",
    flex: 1,
    padding: "1rem",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    color: "#005BBB",
    fontWeight: 700,
  };

  // Número destacado
  const numberStyle = {
    fontSize: "1.5rem",
    marginBottom: "0.25rem",
  };

  // Texto explicativo en mayúsculas pequeño
  const labelStyle = {
    marginLeft: "9px",
    fontSize: "1rem",
    textTransform: "uppercase",
    textAlign: "center",
  };



class FunnelStart extends Component {
  constructor() {
    super();

    const rango = Array.from({ length: 7 }, (_, index) => index + 10);
    this.state = {
      linkPayUSD: "",
      pricingAPI: {},
      slugBootcamp: "fullstack",
      bootcampSlugMensual: "fullstack",
      Temario: "",
      Programa: "",
      isOpen: false,
      countryCode: "US",
      Email: "",
      Phone: "",
      Name: "",
      isOpenTemario: false,
      isPdfPrice: false,
      langUS: false,
      isPlaying: false,
      isOpenPlanPay: false,
      price_mensual_regular: "",
      price_completo_regular: "",
      price_completo: "",
      price_mensual: "",
      titlePricePre: "",
      demoTitle: "",
      demoUrl: "",
      demoPreview: "",
      fechaLimite:  '',
      dia:  '',
      DescuentoBody: "",
      visitasNumber: this.getRandomVisitasNumber(),
      videoRef: React.createRef(),
      isOpenLead: false,
      loadingEnroll: false,
      demo_alt: false,
      body_intro: false,
      select_mes: "",
      DataFechas: [],
      select_turno: "",
      isOpenResume: false,
      Turnos: [
        {key: "noche", label: "Noche"},
        {key: "tarde", label: "Tarde"},
    ],
      durationVideo: 0,
      durationPercen: 0,
      registerRequerid: false,
      videoInit: false,
      selectFecha: false,
      isModalWS: false,
      optionPlanPago: "0",
      showMore: false,
      showWeb: true,
      fbclid_short_code: "",
      fechaSelect: "",
      horaSelect: "",
      KeysPlanes: [
        {"label": "Entrada Gratuita (1 Sesión)", "key": "0"},
        {"label": "💎 Golden Pass VIP (Acceso Premium)", "key": "1"}
      ]
    };
    this.GetLinkWS = this.GetLinkWS.bind(this);
    this.GetLinkPay = this.GetLinkPay.bind(this);
    
    this.openApp = this.openApp.bind(this);
    this.openModalEmail = this.openModalEmail.bind(this);
    this.onRenderOption = this.onRenderOption.bind(this);
    this.DownloadPdf = this.DownloadPdf.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    // this.getFbclid = this.getFbclid.bind(this);
    // this.generarCodigoCorto = this.generarCodigoCorto.bind(this);
    // this.eventPing = this.eventPing.bind(this);
    // this.DynamicCountry = this.DynamicCountry.bind(this);
    
  }

getTimeSlots() {
  const slots = [];

  // Recorremos desde la hora 8 (8 AM) hasta la 23 (11 PM)
  for (let hour = 8; hour <= 23; hour++) {
    // Calculamos hora en formato 12h
    const hour12 = hour % 12 === 0 ? 12 : hour % 12;
    const suffix = hour < 12 ? 'AM' : 'PM';

    const label = `${hour12}:00 ${suffix}`;
    // key como string, empezando en "1"
    slots.push({
      key: (hour - 7).toString(), // 8→"1", 9→"2", …, 23→"16"
      label: label
    });
  }

  return slots;
}

  getOptionsWithDates() {
  const weekdays = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
  const months   = [
    'enero', 'febrero', 'marzo', 'abril',
    'mayo', 'junio', 'julio', 'agosto',
    'septiembre', 'octubre', 'noviembre', 'diciembre'
  ];

  // Elementos que siempre deben ir al inicio
  const result = [
    { key: "1", label: "Ver ahora al instante" },
    { key: "2", label: "Ver más tarde (hoy)" }
  ];

  // A partir de aquí, generamos las dos fechas siguientes
  for (let i = 1; i <= 2; i++) {
    const d = new Date();
    d.setDate(d.getDate() + i);

    const weekdayShort = weekdays[d.getDay()];
    const dayNum       = d.getDate();
    const monthName    = months[d.getMonth()];
    const yearNum      = d.getFullYear();

    const formatted = `${weekdayShort}, ${dayNum} de ${monthName} de ${yearNum}`;

    // Asignamos key como string: "3" para la primera fecha, "4" para la segunda, etc.
    result.push({
      key: (2 + i).toString(),
      label: formatted
    });
  }

  return result;
}



    onRenderOption(option, complete) {
      return (
        <li>
          <b>
          {complete ? option.label : option.label}
          </b>
        </li>
      );
    }
  
  
    onRenderSelection( selected, settings, deselect ){
        return 	(<span style={{ marginRight: 0, padding: 5 }}>
		{ selected ?
            <span style={{"color": "#1f1f25", padding: "7px", fontSize: "16px"}}>
               {selected.label}
            </span>
            :
               <span style={{padding: 5}}>Modalidad</span>
        }
		<i style={{ paddingLeft: 5, cursor: "pointer" }} onClick={ deselect } className="fa fa-window-close"></i>
	</span>)
    }


    onRenderSelectionPlan( selected, settings, deselect ){
        return 	(<span style={{ marginRight: 10, padding: 5 }}>
		{ selected ?
            <span style={{"color": "#1f1f25", padding: "10px", fontSize: "18px", fontWeight: "bold"}}>
               {selected.label}
            </span>
            :
               <span style={{padding: 5, fontSize: "17px", fontWeight: "bold"}}>Selecciona la fecha</span>
        }
		<i style={{ paddingLeft: 5, cursor: "pointer" }} onClick={ deselect } className="fa fa-window-close"></i>
	</span>)
    }

      onRenderSelectionPlanHorario( selected, settings, deselect ){
        return 	(<span style={{ marginRight: 10, padding: 5 }}>
		{ selected ?
            <span style={{"color": "#1f1f25", padding: "10px", fontSize: "18px", fontWeight: "bold"}}>
               {selected.label}
            </span>
            :
               <span style={{padding: 5, fontSize: "17px", fontWeight: "bold"}}>Selecciona la hora</span>
        }
		<i style={{ paddingLeft: 5, cursor: "pointer" }} onClick={ deselect } className="fa fa-window-close"></i>
	</span>)
    }


  onSubmit(e) {
    // e.preventDefault();
if (this.state.Name.trim() === "") {
  toast.dark('¡Hey! No te olvides de poner tu nombre, así sabremos cómo saludarte 😊');
  return;
}

if (this.state.Email.trim() === "" || !this.state.Email.trim().includes("@")) {
  toast.dark('¡Uy! El email es clave para seguir 📧');
  return;
}

    // if (this.state.Phone.trim() === "" || this.state.Phone.trim().length < 7) {
    //   toast.dark('¡Ups! El campo Celular es necesario para continuar.');
    //   return;
    // }

    this.setState({ loadingEnroll: true, sendDataForm: true });

    localStorage.setItem("email", this.state.Email || "");
    localStorage.setItem('name', this.state.Name);

    // if (this.state.Phone){
    //   localStorage.setItem('phone', this.state.Phone);
    // }

          window.fbq('track', 'Lead', {
            content_name: 'Registro formulario Bootcamp',
            content_category: 'Full Stack Online'
          });

    // window.fbq('track', 'Contact', {
    //   content_name: 'Formulario de contacto Bootcamp',
    //   content_category: 'Full Stack Online'
    // });

    if (this.state.fechaSelect === "1"){
      setTimeout(() => {
            window.location.href = "/masterclass/unirme";
        }, 1900);
    } else {
          setTimeout(() => {
            this.setState({loadingEnroll: false, isModalWS: true });
        }, 1000);
    }

    axios
      .post("https://cprij4toee.execute-api.us-east-1.amazonaws.com/dev", {
        lead: true,
        evento: true,
        bootcamp: "Web full stack",
        email: this.state.Email,
        name: this.state.Name,
        country: this.state.countryCode,
        phone: this.state.Phone,
        Token: "c3b4b89c",
        landing: 'Masterclass',
        ticket: "" ,
        source: window.location.search,
      })
      .then((res) => {

        this.setState({loadingEnroll: false });


        // window.location.href = "/bootcamp";


        // setTimeout(() => {
        //   const link = this.GetLinkWS();
        //   window.open(link, '_blank').focus();
        //   // window.location.href = "/bootcamp";
        // }, 3500);

        // window.location.href = "/intro-fullstack";
        // const link = this.GetLinkWS();
        // this.setState({loadingEnroll: false });
        // window.open(link, '_blank').focus();
      });
  }

  getRandomVisitasNumber() {
    const rango = Array.from({ length: 7 }, (_, index) => index + 10);
    return rango[Math.floor(Math.random() * rango.length)];
  }

  sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };


  
  



  GetLinkWS() {
    return `https://api.whatsapp.com/send?phone=51936670597&text=Hola, me gustaría acceder al Masterclass del Bootcamp Full Stack`;
  }


  GetLinkPay() {
    let linkVipPeru = "https://mpago.la/1PxXuL5";
    let linkVipUSD = "https://buy.stripe.com/9AQ5l27jm7vIeoofZm";
    if (this.state.countryCode.toLocaleUpperCase() === "PE" ){
      return linkVipPeru
    } else {
      return linkVipUSD
    }
  }



  openModalEmail() {
    this.setState({ Phone: "" });
    this.setState({ isOpenTemario: !this.state.isOpenTemario });
  }

  openApp(){
    const link = this.GetLinkWS();
    window.open(link, '_blank').focus();
  }

  DownloadPdf(e) {
    e.preventDefault();

    if (this.state.Email === "") {
      toast.warning("El campo Email es requerido.");
      return;
    }

    localStorage.setItem("email", this.state.Email);

    toast.success(
      !this.state.langUS
        ? "Hola!, enviamos el programa por Email, gracias!"
        : "Hello! We sent the program by Email, thank you!"
    );

    this.openModalEmail();

    axios
      .post("https://cprij4toee.execute-api.us-east-1.amazonaws.com/dev", {
        lead: true,
        evento: true,
        bootcamp: this.state.slugBootcamp,
        email: this.state.Email,
        name: this.state.Name,
        country: this.state.countryCode,
        Token: "c3b4b89c",
      })
      .then((res) => {
        window.gtag_report_conversion();
        // window.location.href = `/inscripcion/fullstack/${this.state.countryCode}`;
        // toast.success(`Hola ${this.state.Name}!, tengamos una breve sesión informativa para completar tu inscripción`);
      });
  }



onRenderSelection( selected, complete ){
    return 	(<span style={{ padding: 2 }}>
    { selected ?
        <span style={{"color": "black"}}>
              {selected.label }
        </span>
        :
           <span style={{padding: 5}}></span>
    }
</span>)
}

renderCard2(index, modIndex) {
  const item = data2[modIndex];
  return (
      <div
      key={index}
      className="carousel-card"
      >
      <div style={{width: "275px"}}>
         <div style={{"text-align":"center", "box-shadow": "4px 2px 5px 0px #8080805e", "border-radius": "30px", "padding": "23px", "background": "white"}}>
              <h4>
              {item.title}
              </h4>
              <img alt={item.title} height="130px" src={item.background} />
          </div>
      </div>
      </div>
  );
  }


renderPais(complete=false){
    return (
        <>
        <span style={{
            fontSize: "17px",
            fontWeight: "bold",
            position: "absolute",
            left: "15px",
            top: "-25px",
            zIndex: "1",
        }} > Zona horaria </span>
            <Selectrix
        height={300}
        onRenderOption={(option) => this.onRenderOption(option, complete)}
        onRenderSelection={(option) => this.onRenderSelection(option, complete)}
        placeHolderInside={true}
        placeholder={"País"}
        customScrollbar={true}
        searchable={false}
        materialize={false}
        defaultValue={this.state.countryCode}
        options={KeyCountry}
  
    />
        </>

    )
}




renderMes(){
    return (
        <>
        <span style={{
            fontSize: "17px",
            fontWeight: "bold",
            position: "absolute",
            left: "15px",
            top: "-25px",
            zIndex: "1",
        }} > {!this.state.langUS ? "Mes:": "Month:"} </span>
        <Selectrix
        height={250}
        placeHolderInside={true}
        placeholder={"Todos"}
        customScrollbar={true}
        searchable={false}
        materialize={false}
        defaultValue={this.state.select_mes}
        options={this.state.DataFechas.map((item) => ({key: item.mes, label: item.mes})) }
        onChange={value => this.setState({select_mes: value.key})}
    />
        </>

    )
}

renderTurno(){
    return (
        <>
        <span style={{
            fontSize: "17px",
            fontWeight: "bold",
            position: "absolute",
            left: "15px",
            top: "-25px",
            zIndex: "1",
        }} >{!this.state.langUS ? "Turno": "Shift"}:</span>
        <Selectrix
        height={250}
        placeHolderInside={true}
        placeholder={!this.state.langUS ? "Todos": "All" }
        customScrollbar={true}
        searchable={false}
        materialize={false}
        defaultValue={this.state.select_turno}
        options={this.state.Turnos}
        onChange={value => this.setState({select_turno: value.key})}
    />
        </>

    )
}

    renderHorario(){
    if (this.state.utc_offset === "-0500") {
        return  <p style={{fontSize: "18px", fontWeight: 500}} className="mb-1">7:00 PM a 9:35 PM</p>
    } else if (this.state.utc_offset === "-0600") {
        return  <p style={{fontSize: "18px", fontWeight: 500}} className="mb-1">6:00 PM a 8:35 PM</p>
    } else if (this.state.utc_offset === "-0400"){
        return  <p style={{fontSize: "18px", fontWeight: 500}} className="mb-1">8:00 PM a 10:35 PM</p>
    }  else {
        return  <p style={{fontSize: "18px", fontWeight: 500}} className="mb-1">7:00 PM a 9:35 PM</p>
    }
}
      renderHorarioFinSemana(){
        if (this.state.utc_offset === "-0500") {
            return  <p style={{fontSize: "18px", fontWeight: 500}} className="mb-1">9:00 AM a 11:35 AM</p>
        } else if (this.state.utc_offset === "-0600"){
            return  <p style={{fontSize: "18px", fontWeight: 500}} className="mb-1">8:00 AM a 10:35 AM</p>
        } else if (this.state.utc_offset === "-0400"){
            return  <p style={{fontSize: "18px", fontWeight: 500}} className="mb-1">10:00 AM a 12:35 M</p>
        } else {
            return  <p style={{fontSize: "18px", fontWeight: 500}} className="mb-1">9:00 AM a 11:35 AM</p>
        }
    }

    renderHorarioFinSemanaTarde(){
        return (
        <p style={{fontSize: "18px", fontWeight: 500}} className="mb-1">05:00 PM a 7:35 PM</p>
        )
    }

renderFechaSelect(item, key){
    return (
        <div key={key} className="row row--35 align-items-center rn-address" data-aos="fade-up"  style={{boxShadow: "#c6c9d8 8px 6px 15px 1px"}} >
        <div className="col-12 mb-3">

            <h2 style={{marginBottom: "0px", fontSize: window.type_device && "39px" }}>
                {item.fecha_inicio}
            </h2>
            <div style={{width: window.type_device ? "200px": "450px", height: "6px", backgroundColor: "black", marginBottom: "20px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>

            <div className="row">
                <div className="col-lg-2 col-md-3 col-12  mt-2">
                <span style={{padding: "3px", "padding-top": "4px","padding-bottom": "4px", "background-color": "tomato", "border-radius": "7px", "padding-left": "7px", "padding-right": "7px", "color": "white", "font-size": "18px"}}>
                                <FiVideo/> {!this.state.langUS ? "En vivo Gratuito": "Live"}
                                </span>
                </div>
                <div className="col-md-4 col-lg-3 col-12  mt-2">
                    <span style={{"padding-top": "4px","padding-bottom": "4px", "font-size": "18px", "color":"white", "background-color": "slateblue", "border-radius": "8px", "padding-left": "8px", "padding-right": "8px"}}>
                        Plazas limitadas
                    </span>
                </div>
            </div>

        </div>

        <div className="col-md-3 col-12" style={{height: "110px", borderRight: !window.type_device ? "1px solid #121212" : "none" }}>
            <div> <h5 className="mb-2" ><b> {!this.state.langUS ? "Duración": "Duration"} </b></h5> </div>
            <div> <p style={{fontSize: "18px"}}> {!this.state.langUS ? "12 meses": "5 months"}
            <span style={{display: "inline-block"}}></span>
            </p> </div>
            <span className="bg-white m-1" style={{padding: "5px 7px", border: "1px solid mediumpurple", display: "inline-block", borderRadius: "10px", fontSize: "16px"}}>
            <b>{item.fecha_start_end}</b>
            </span>
        </div>

        <div className="col-md-3 col-12" style={{height: "110px", marginTop: window.type_device ? "25px": "none", borderRight: !window.type_device ? "1px solid #121212" : "none" }}>
            <div> <h5 className="mb-2"><b> {!this.state.langUS ? "Días": "Days"} </b></h5> </div>
            <div> <p style={{fontSize: "18px"}}> {item.dias}  </p> </div>
        </div>

        <div className="col-md-3 col-12" style={{height: "110px", marginTop: "none"}}>
            <div> <h5 className="mb-2"><b> {!this.state.langUS ? `Horario (${item.turno})`: `Schedule (${item.turno})`} </b></h5> </div>

            <div className="row">
                <div className="col-12">
                {(item.turno == 'noche' || item.turno == 'night') && this.renderHorario() }
                {item.turno == 'mañana'  && this.renderHorarioFinSemana() }
                {item.turno == 'tarde'  && this.renderHorarioFinSemanaTarde() }
                </div>

            </div>
        </div>

        <div className="col-md-3 col-12" style={{marginTop: "30px"}}>
            <div>
            <a href={"#inscripcion"}>
            <button
            style={{lineHeight: "20px", fontSize: "18px", marginBottom: "13px", padding: "15px 30px" }}
            className=" btn-efect">
            ELEGIR FECHA
            </button>
            </a>
            </div>
        </div>

    </div>
    )
  }

renderFechas() {
    return (
        <div>
            {!this.state.select_mes && this.state.DataFechas.map((item, key) => (

                this.state.select_turno ?
                 this.state.select_turno == item.turno && this.renderFechaSelect(item, key)
                :
                this.renderFechaSelect(item, key)

            ))}

            {this.state.select_mes && this.state.DataFechas.map((item, key) => (

                this.state.select_turno ?
                this.state.select_turno == item.turno && this.state.select_mes == item.mes && this.renderFechaSelect(item, key)
               :
                this.state.select_mes == item.mes && this.renderFechaSelect(item, key)


            ))}
      </div>

    )}





    

  render() {
    const TypingAnimation2 =  React.memo(()=>{
      return !this.state.langUS ?
      <Typical
      steps={['Aprende 100% online en vivo', 500 ,'con la guía de tu Mentor.', 1000]}
      loop={Infinity}
      wrapper="h2"/>
      :
      <Typical
      steps={['Learn 100% online live', 500 ,'with the guidance of your Mentor.', 1000]}
      loop={Infinity}
      wrapper="h2"
  />
    },(props,prevProp)=> true ); // this line prevent re rendering
    

    return (
      <React.Fragment>
        {/* Start Pagehelmet  */}
        <PageHelmet pageTitle="Masterclass - Bootcamp Web Full Stack" />
        {/* End Pagehelmet  */}


        <div className="w-100 dojo-mural-2 pb-2" >
            <video
    poster="/assets/images/dojopy/bg-image-funnel-vid.webp" 
    className="dojo-mural__video"
    src="/assets/images/dojopy/bg-video-funnel.mp4"
    autoPlay
    muted
    loop
    playsInline
  />
  <div className="dojo-mural__video-overlay"></div>

      <div className=" title-mural" style={{justifyItems: "center", position: "relative", zIndex: "100000", paddingTop: "10px", paddingBottom: "20px"}}>

        <div  style={{paddingLeft: "1px",  paddingTop: "10px", textAlign: "center", justifyItems: "center"}} >
    
    <div className="d-flex">
     <a href={'/masterclass'}>
        <img style={{borderRadius: "50%"}} height="40px" class="logo-1" src="/assets/images/logo/logo_dojo_2026.webp" alt="DojoFullStack"/>
    </a>
     <div className="logo_dojopy" style={{color: "white", marginTop: "10px", fontFamily: "'El Messiri', sans-serif", lineHeight: "17px", "place-self": "center", "margin-left": "3px"}}>
                        <a href={"/masterclass"} >
                            <span style={{fontFamily: "'El Messiri', sans-serif", fontSize: window.type_device ? "25px": "25px" }}>
                                DOJO
                            </span>
                            <span style={{marginLeft: "1px", fontFamily: "'El Messiri', sans-serif", fontSize: window.type_device ? "11px": "11px", display: "block"}}>
                                FULL STACK
                            </span>
                            </a>
                        </div>
    </div>
      </div>
        
   </div>

    </div>
 




     <div className="dojo-mural__contenido">

        <h3 className="my-2 text-center subtitle-mural" style={{color: "white", fontSize: window.type_device ? "36px": "59px" }} >
         Desde Cero a <br/> Programador <br/> Full Stack
          </h3>
      <h5 className="text-center subtitle-mural mt-2" style={{color: "white", fontSize: window.type_device ? "19px": "23px" }} >
           Empieza tu camino digital, <br/>
trabaja flexible y gana en dólares.
          </h5>

<div
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "24px 0"
  }}
>
  <button
    onClick={() => document.querySelector('#registro').scrollIntoView({ behavior: 'smooth' })}
    style={{
      textShadow: "none",
      cursor: "pointer",
      fontWeight: 600,
      fontSize: "18px",
      padding: "10px 19px",
      borderRadius: "20px",
      background: "linear-gradient(180deg,#ffe26d,#f5c918)",
      color: "black",
      border: "none",
      outline: "none"
    }}
    className="btn-efect-live"
  >
    Reserva mi lugar ahora
  </button>
</div>
          
     </div>

      

    








<div className="about-wrapper mt-3" style={{paddingTop: window.type_device ? "5px": "50px" }} id="Masterclass">


<div   className={window.type_device ? "container-fluid ": "container"}>

<div className="inner">
    <div className="contact-form--1 p-3">
            <div className="row justify-content-center" data-aos="fade-right" >

<div className="col-12 col-md-5 p-3 mt-1" style={{borderRadius: "20px", marginBottom: "20px", boxShadow: "0 5px 12px 0 rgba(33,43,54,.07),0 10px 30px 0 rgba(33,43,54,.085)"}}  id="registro">


                <h3
                className="mb-1 mt-2 text-center"
                     style={{borderRadius: "9px", color: "white", backgroundColor: "#7a12d4", fontWeight: "bold", display: "block", padding: "10px", "padding-left": "15px", "padding-right": "15px", "font-size": window.type_device ? "18px": "20px" }}>
                   <FaFilm className="mr-2" />
   Disponible por tiempo limitado
                    </h3>

<div className="px-1" style={{paddingTop: "5px", paddingBottom: "5px" }}>

 <label className="col-12 text-left font-weight-bold text-black" htmlFor="nameDojo">
                   
          <span style={{fontWeight: "normal", fontFamily: "'Poppins',sans-serif", padding: "5px", color: "black", fontSize: "17px", display: "inline-block", marginBottom: "1px"}}>
                     Nombre *
          </span>
                            <input
                            id='nameDojo'
                            style={{marginBottom: "5px", backgroundColor: 'white'}}
                            type="text"
                            name="name"
                            value={this.state.Name}
                            onChange={(e) => this.setState({ Name: e.target.value})}
                            placeholder= {"Nombre"}
                            />
                        </label> 

<label className="col-12 text-left font-weight-bold text-black mt-1" htmlFor="emailDojo">
          <span style={{fontWeight: "normal", fontFamily: "'Poppins',sans-serif", padding: "5px", color: "black", fontSize: "17px", display: "inline-block", marginBottom: "1px"}}>
          📧 Correo Electrónico *
          </span>
          <input
          style={{marginBottom: "5px", backgroundColor: 'white'}}
          type="email"
          name="email"
          id="emailDojo"
          value={this.state.Email}
          onChange={(e) => this.setState({ Email: e.target.value})}
          placeholder="Correo Electrónico"
            />
</label>


   <div className="mx-2 mt-3">
                    <Selectrix
                    className="pais-inscription cuotas-inscription"
                    height={300}
                        onRenderOption={this.onRenderOption}
                        onRenderSelection={this.onRenderSelectionPlan}
                        placeHolderInside={true}
                        placeholder={""}
                        customScrollbar={true}
                        searchable={false}
                        materialize={false}
                        defaultValue={this.state.fechaSelect}
                        options={this.getOptionsWithDates()}
                        onChange={(value) => {
                            this.setState({fechaSelect: value.key});
                        }}
                    />
</div>

{this.state.fechaSelect !== "1" &&
   <div className="mx-2 mt-3">
                    <Selectrix
                    className="pais-inscription cuotas-inscription"
                    height={300}
                        onRenderOption={this.onRenderOption}
                        onRenderSelection={this.onRenderSelectionPlanHorario}
                        placeHolderInside={true}
                        placeholder={""}
                        customScrollbar={true}
                        searchable={false}
                        materialize={false}
                        defaultValue={this.state.horaSelect}
                        options={this.getTimeSlots()}
                        onChange={(value) => {
                            this.setState({horaSelect: value.key});
                        }}
                    />
</div>
  }


 {/* <label className="col-12 text-left font-weight-bold text-black mt-2" htmlFor="">
<div className="text-left mt-1 pt-1" >
    <span style={{fontWeight: "normal", fontSize: "18px", color: "black", fontFamily: "'Poppins',sans-serif"}}>
    📲 Tu número de WhatsApp
    </span>
</div>
</label> */}

 {/* <div className="d-flex justify-content-center mx-2">

<div className="mx-2 mt-2">
    <Selectrix
    className="pais-inscription"
    height={300}
    onRenderOption={this.onRenderOption}
    onRenderSelection={this.onRenderSelection}
    placeHolderInside={true}
    placeholder={"País"}
    customScrollbar={true}
    searchable={false}
    materialize={false}
    defaultValue={this.state.countryCode}
    options={KeyCountry}
    onChange={(value) => {
      this.setState({"countryCode": value.key});
        if (this.state.Email){
            localStorage.setItem('email', this.state.Email);
        }
        if (this.state.Name){
            localStorage.setItem('name', this.state.Name);
        }
        if (this.state.Phone){
            localStorage.setItem('phone', this.state.Phone);
        }
    } }
    />

</div>

<div style={{width: "80%"}}>
<label htmlFor="Phone">
    
    <input
    style={{background: "white"}}
    type="tel"
    name="phone"
    id="Phone"
    value={this.state.Phone}
    onChange={(e) => {
        this.setState({ Phone: e.target.value });
    }}
    placeholder="987654321"
    />
 </label>
</div>
</div>  */}



<div className="d-flex justify-content-center mx-2 mt-2">

<button
      onClick={this.onSubmit}
      disabled={this.state.loadingEnroll}
      id="submit-contacto"
      className="btn-efect-live boton-bombeo"
      type="btn" name="submit-contacto"  style={{borderRadius: "20px", padding: "10px 30px", background: "linear-gradient(180deg,#ffe26d,#f5c918)", color: "black", fontSize: "21px", display: "inline-block", margin: "auto", textTransform: "capitalize"}}>

{this.state.loadingEnroll  &&
      <Spinner
      as="span"
      animation="border"
      size="sm"
      role="status"
      aria-hidden="true"
      style={{fontSize: "20px", marginRight: "8px"}}
      />
}

Reserva mi lugar ahora

</button>
  
</div>

    
</div>



</div>
</div>
</div>
</div>






<div class="row my-3 justify-content-center" id="seccion-destino">

   <div className="col-12">
 <div class="row my-1 justify-content-center">
                <div class="col-12 mt-1" >
                      <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={numberStyle}>
          <FaUserFriends className="mr-2"/> 3,300+</div>
        <div style={labelStyle}>Participantes</div>
      </div>

      <div style={cardStyle}>
        <div style={numberStyle}>
          <MdAccessTimeFilled className="mr-2"/> 2</div>
        <div style={labelStyle}>Horas de Masterclass</div>
      </div>

      <div style={cardStyle}>
        <div style={numberStyle}>
          <FaMedal className="mr-2"/> 6,321</div>
        <div style={labelStyle}>Historias de Éxito</div>
      </div>
    </div>
              </div>               
      </div>  
   </div>

      
                    <div class="col-12 col-md-7 mt-5" >
                        <div class="section-title service-style--3 mb--25 mb_sm--0 text-center">
                            <h3 class="title text-black px-4 mb-1" style={{fontSize: window.type_device ? "30px": "38px", lineHeight: "1.4"}}>
                            Lo que aprenderás:
                             </h3>
                             <div className=" mx-auto" style={{width: window.type_device ? "250px": "395px", height: "6px", backgroundColor: "gold", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>

                              <div className="d-flex justify-content-center gap-3 flex-wrap flex-column" style={{gap: "20px"}}>

                             <div style={{padding: "20px", borderRadius: "30px", boxShadow: "0 5px 10px 0px rgba(16,5,35,0.15)"}} className="d-flex justify-content-center flex-column align-items-center">
                              <img className="col-12 col-md-6 px-0" style={{width: "175px", borderRadius: "30px"}} src="/assets/images/dojopy/idea-coding-boot.png" alt="" srcset="" />
                             <p className="py-2" style={{fontWeight: "500", fontSize: "18px"}}>

                             💻 Estrategias comprobadas para aprender desarrollo y programación desde cero.

                              </p>
                             </div>

                             <div style={{padding: "20px", borderRadius: "30px", boxShadow: "0 5px 10px 0px rgba(16,5,35,0.15)"}} className="d-flex justify-content-center flex-column align-items-center">
                              <img className="col-12 col-md-6 px-0" style={{width: "175px", borderRadius: "30px"}} src="/assets/images/dojopy/profile_4.png" alt="" srcset="" />
                             <p className="py-2" style={{fontWeight: "500", fontSize: "18px"}}> 

                             🛠️ Aprende a construir aplicaciones web y apps profesionales.
                             </p>
                             </div>

                             <div style={{padding: "20px", borderRadius: "30px", boxShadow: "0 5px 10px 0px rgba(16,5,35,0.15)"}} className="d-flex justify-content-center flex-column align-items-center">
                              <img className="col-12 col-md-6 px-0" style={{width: "175px", borderRadius: "30px"}} src="/assets/images/dojopy/empleos-2026.png" alt="" srcset="" />
                             <p className="py-2" style={{fontWeight: "500", fontSize: "18px"}}> 
                             📈 Descubre cómo acceder a empleos en tecnología de alta demanda, incluso si empiezas desde cero.
                              </p>
                             </div>



                             <div style={{padding: "10px", borderRadius: "30px"}} className="d-flex justify-content-center flex-column align-items-center">
                             <p className="py-1" style={{fontWeight: "500", fontSize: "20px"}}> <b> ¡Y Más!</b> </p>
                             </div>

                             </div>

                             
                        </div>
                    </div>
                    </div>


                    <div class="row my-2">
                    <div class="col-lg-12 col-12 my-2" >
                        <div class="section-title service-style--3 mb--25 mb_sm--0 text-center">
                          
                             <div className="d-flex justify-content-center flex-column align-items-center">

                              <h3 class="title text-black px-1 my-2" style={{fontSize: window.type_device ? "30px": "38px", lineHeight: "1.4"}}>
                              Únete a la Masterclass gratuita hoy
                             </h3>


                             <div className="inner">
    <div className="contact-form--1 p-3">
            <div className="row justify-content-center"  >

<div data-aos="fade-right" className="col-12 p-3 mt-1" style={{borderRadius: "20px", marginBottom: "20px", boxShadow: "0 5px 12px 0 rgba(33,43,54,.07),0 10px 30px 0 rgba(33,43,54,.085)"}}  id="registro-2">


                <h3
                className="mb-1 mt-2 text-center"
                     style={{borderRadius: "9px", color: "white", backgroundColor: "#7a12d4", fontWeight: "bold", display: "block", padding: "10px", "padding-left": "15px", "padding-right": "15px", "font-size": window.type_device ? "18px": "20px" }}>
                   <FaFilm className="mr-2" />
   Disponible por tiempo limitado
                    </h3>

<div className="px-1" style={{paddingTop: "5px", paddingBottom: "5px" }}>

 <label className="col-12 text-left font-weight-bold text-black" htmlFor="nameDojo">
                   
          <span style={{fontWeight: "normal", fontFamily: "'Poppins',sans-serif", padding: "5px", color: "black", fontSize: "17px", display: "inline-block", marginBottom: "1px"}}>
                     Nombre *
          </span>
                            <input
                            id='nameDojo'
                            style={{marginBottom: "5px", backgroundColor: 'white'}}
                            type="text"
                            name="name"
                            value={this.state.Name}
                            onChange={(e) => this.setState({ Name: e.target.value})}
                            placeholder= {"Nombre"}
                            />
                        </label> 

<label className="col-12 text-left font-weight-bold text-black mt-1" htmlFor="emailDojo">
          <span style={{fontWeight: "normal", fontFamily: "'Poppins',sans-serif", padding: "5px", color: "black", fontSize: "17px", display: "inline-block", marginBottom: "1px"}}>
          📧 Correo Electrónico *
          </span>
          <input
          style={{marginBottom: "5px", backgroundColor: 'white'}}
          type="email"
          name="email"
          id="emailDojo"
          value={this.state.Email}
          onChange={(e) => this.setState({ Email: e.target.value})}
          placeholder="Correo Electrónico"
            />
</label>


   <div className="mx-2 mt-3">
                    <Selectrix
                    className="pais-inscription cuotas-inscription"
                    height={300}
                        onRenderOption={this.onRenderOption}
                        onRenderSelection={this.onRenderSelectionPlan}
                        placeHolderInside={true}
                        placeholder={""}
                        customScrollbar={true}
                        searchable={false}
                        materialize={false}
                        defaultValue={this.state.fechaSelect}
                        options={this.getOptionsWithDates()}
                        onChange={(value) => {
                            this.setState({fechaSelect: value.key});
                        }}
                    />
</div>
  
{this.state.fechaSelect !== "1" &&
   <div className="mx-2 mt-3">
                    <Selectrix
                    className="pais-inscription cuotas-inscription"
                    height={300}
                        onRenderOption={this.onRenderOption}
                        onRenderSelection={this.onRenderSelectionPlanHorario}
                        placeHolderInside={true}
                        placeholder={""}
                        customScrollbar={true}
                        searchable={false}
                        materialize={false}
                        defaultValue={this.state.horaSelect}
                        options={this.getTimeSlots()}
                        onChange={(value) => {
                            this.setState({horaSelect: value.key});
                        }}
                    />
</div>
  }


 {/* <label className="col-12 text-left font-weight-bold text-black mt-2" htmlFor="">
<div className="text-left mt-1 pt-1" >
    <span style={{fontWeight: "normal", fontSize: "18px", color: "black", fontFamily: "'Poppins',sans-serif"}}>
    📲 Tu número de WhatsApp
    </span>
</div>
</label> */}

 {/* <div className="d-flex justify-content-center mx-2">

<div className="mx-2 mt-2">
    <Selectrix
    className="pais-inscription"
    height={300}
    onRenderOption={this.onRenderOption}
    onRenderSelection={this.onRenderSelection}
    placeHolderInside={true}
    placeholder={"País"}
    customScrollbar={true}
    searchable={false}
    materialize={false}
    defaultValue={this.state.countryCode}
    options={KeyCountry}
    onChange={(value) => {
      this.setState({"countryCode": value.key});
        if (this.state.Email){
            localStorage.setItem('email', this.state.Email);
        }
        if (this.state.Name){
            localStorage.setItem('name', this.state.Name);
        }
        if (this.state.Phone){
            localStorage.setItem('phone', this.state.Phone);
        }
    } }
    />

</div>

<div style={{width: "80%"}}>
<label htmlFor="Phone">
    
    <input
    style={{background: "white"}}
    type="tel"
    name="phone"
    id="Phone"
    value={this.state.Phone}
    onChange={(e) => {
        this.setState({ Phone: e.target.value });
    }}
    placeholder="987654321"
    />
 </label>
</div>
</div>  */}



<div className="d-flex justify-content-center mx-2 mt-2">

<button
      onClick={this.onSubmit}
      disabled={this.state.loadingEnroll}
      id="submit-contacto"
      className="btn-efect-live boton-bombeo"
      type="btn" name="submit-contacto"  style={{borderRadius: "20px", padding: "10px 30px", background: "linear-gradient(180deg,#ffe26d,#f5c918)", color: "black", fontSize: "21px", display: "inline-block", margin: "auto", textTransform: "capitalize"}}>

{this.state.loadingEnroll  &&
      <Spinner
      as="span"
      animation="border"
      size="sm"
      role="status"
      aria-hidden="true"
      style={{fontSize: "20px", marginRight: "8px"}}
      />
}

Reserva mi lugar ahora

</button>
  
</div>

    
</div>



</div>
</div>
</div>
</div>

  

                             </div>
                        </div>
                    </div>
                    </div>














                    {/* <div class="row my-5">
                    <div class="col-lg-12 col-12 mt-4" >
                        <div class="section-title service-style--3 mb--25 mb_sm--0 text-center">
                            <h3 class="title text-black px-4">
                            Empresas Globales Quieren Tu Talento
                             </h3>

                             <div className="d-flex justify-content-center">
                              <img className="col-12 col-md-6 w-100 img-fluid" src="/assets/images/dojopy/brands_2025.png" alt="" srcset="" />
                             </div>
                        </div>
                    </div>
                    </div> */}


    </div>
    {/* {this.renderFormLead("🎓 Solicitar mi Beca Parcial + Brochure")} */}


    <FooterTwoFunnel  />

  </div>







<Modal aria-labelledby="contained-modal-title-vcenter"
      centered show={this.state.isModalWS} size={window.type_device ? "md": "lg"} onHide={() => this.setState({isModalWS: true})} style={{zIndex: "9999999999"}} >

                    <Modal.Body>
                    <div className="about-inner inner">
                        <div className="section-title">
                          <h3 className="p-1 text-dark" style={{marginTop: window.type_device ? "1px": "20px",  fontSize: "25px"}}>
                            ✅ ¡Genial,  {this.state.Name}!
                            </h3>
                          <p className="p-1 text-dark mb-1">
                            <b>
    Gracias por registrarte. Muy pronto recibirás en tu correo 📧 el enlace para que veas la masterclass 📅 en el día y la hora que elegiste.
                            </b>
                            </p>
                                 <p className="p-1 text-dark mb-1">
    Mientras tanto, revisa tu bandeja de entrada (y la carpeta de spam, por si acaso).  
    ¡Nos vemos en la clase! 🎥
                            </p>

                            {/* <div className="w-100 m-1">
                              <button onClick={() => {
                                 const link = this.GetLinkWS();
                                 window.open(link, '_blank').focus();
                              }}
                              className="btn-efect-live boton-bombeo"
                              style={{background: "mediumspringgreen", borderRadius: "15px", color: "#1d1d24", width: "100%", fontSize: "23px", display: "block", margin: "auto", textTransform: "capitalize"}}>
                                <FaWhatsapp style={{fontSize: "25px", marginRight: "7px"}}/>
                                Confirmar por WhatsApp
                                </button>

                           
                            </div> */}

                           
                    </div>
                    </div>
                    </Modal.Body>
</Modal>
                



  <div id="boton-flotante"  style={{textAlign: "center", width: "100%" ,flexDirection: "column", alignSelf: "center", position: "fixed", bottom: "20px", zIndex: "9999999999", display: "none"}}>
    <button
    onClick={() => document.querySelector('#registro').scrollIntoView({ behavior: 'smooth' })}
    style={{
      textShadow: "none",
      cursor: "pointer",
      fontWeight: 600,
      fontSize: "18px",
      padding: "10px 19px",
      borderRadius: "20px",
      background: "linear-gradient(180deg,#ffe26d,#f5c918)",
      color: "black",
      border: "none",
      outline: "none"
    }}
    className="btn-efect-live"
  >
    Reserva mi lugar ahora
  </button>
    </div>

     




  




<ToastContainer
                position="bottom-center"
                autoClose={9000}
                zIndex={10000}
                />


      </React.Fragment>
    );
  }



    eventPing(fbclid_short_code, fbclid) {
        const payload = {
          "event_name": "fbclid",
          "fbclid_short_code": fbclid_short_code,
          "fbclid": fbclid
       }
       axios.post("https://api.dojofullstack.com/api/v1/crm/event-fbclid", payload).then((res) => {
       })
      };
  



  runtDiscountHot(codeDiscount){
    // console.log("module runDiscountFlash!");

    const getCookieValue = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    const discount60mValue = getCookieValue(`discount-temporal-${codeDiscount}`);
    const discount24hValue = getCookieValue(`discount-reboot-${codeDiscount}`);

    if (discount60mValue){
        console.log("DESCUENTO ACTIVO!");
        const discount60mDate = new Date(parseInt(discount60mValue, 10));
        // console.log(discount60mDate);
        this.setState({fechaLimite: discount60mDate})
        return;
    }


    if ( !discount60mValue && !discount24hValue){
        console.log("CREANDO DESCUENTO!");

        const fechaActual = new Date();
        const fechaActual2 = new Date();

        const minutes = 60*12;
        const houresReboot = 24;

        fechaActual.setTime(fechaActual.getTime() +  (minutes * 60 * 1000) );
        fechaActual2.setTime(fechaActual2.getTime() +  (houresReboot * 60 * 60 * 1000) );

        document.cookie = `discount-temporal-${codeDiscount}=${fechaActual.getTime()};expires=${fechaActual.toUTCString() }; path=/`;
        document.cookie = `discount-reboot-${codeDiscount}=${fechaActual2.getTime()};expires=${fechaActual2.toUTCString() }; path=/`;
        this.setState({fechaLimite: fechaActual})
    } else if (!discount60mValue && discount24hValue){
        console.log("FINALIZO EL DESCUENTO!");
        this.setState({showDeadLine: false});
        window.location.href = `/`;
    }
   
}

  async componentDidMount() {
    // document.getElementById('whatsapp').style.display='block';
    // document.body.style.backgroundColor = "rgb(27, 18, 18)";

    // window.urlWasi = this.GetLinkWS();


    const target = document.getElementById('seccion-destino');
    const boton = document.getElementById('boton-flotante');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          boton.style.display = 'block';
        } else {
          boton.style.display = 'none';
        }
      });
    }, {
      root: null, // viewport
      threshold: 0.4 // visible al menos 50%
    });

    observer.observe(target);



    const respo = await axios.get(
      "https://edxcwnqqclvq7dccamuytezonu0hqrod.lambda-url.us-east-1.on.aws/"
    );
    const responseDemo = respo.data["evento"];
    this.setState({fechaLimite: responseDemo.fechaLimite, dia: responseDemo.dia});

    try {
      const responseIP = await axios.get("https://ipapi.co/json/");
      let dataPriceIP = responseIP.data;
      if (!dataPriceIP.country_code) throw "api error";
      this.setState({countryCode: dataPriceIP.country_code});

  } catch {
      axios.get('https://bdzpehnjfmdq56bcrp6gb4mcru0nxqci.lambda-url.us-east-1.on.aws/').then((response) => {
          let data = response.data;

          this.setState({countryCode: data.country_code});
          }).catch((error) => {
              console.log("error api");
          });
  }


      // this.showMatrix();



  }
}

export default FunnelStart;
